import { mapState, mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import moment from 'moment'

export function isOlderVersion (currentVersion, targetVersion) {
  if (!currentVersion || !targetVersion) return false
  const parts1 = String(currentVersion).split('.').map(p => parseInt(p, 10) || 0)
  const parts2 = String(targetVersion).split('.').map(p => parseInt(p, 10) || 0)
  const maxLen = Math.max(parts1.length, parts2.length)
  for (let i = 0; i < maxLen; i++) {
    const num1 = parts1[i] || 0
    const num2 = parts2[i] || 0
    if (num1 < num2) return true
    if (num1 > num2) return false
  }
  return false
}

export default {
  data () {
    return {
      showTimeOut: false,
      interval: null,
      version: process.env.VUE_APP_VERSION,
      showRecommendRefresh: false,
      showForceRefresh: false,
      offline: false
    }
  },
  watch: {
    loggedIn () {
      if (!this.loggedIn) {
        if (this.$route.name !== "Login") {
          this.$router.push({ name: 'Login', query: { from: this.$route.fullPath } })
        }
      }
    }
  },
  computed: {
    ...mapGetters('auth', [
      'tokenExpires',
      'loggedIn',
      'lastActivity'
    ]),
    ...mapState('auth', [
      'user'
    ]),
    iconUrl () {
      if (process.env.NODE_ENV !== 'production' && (axios.defaults.params && axios.defaults.params['SUBDOMAIN'])) {
        return axios.defaults.baseURL + '/users/org/icon/?SUBDOMAIN=' + axios.defaults.params['SUBDOMAIN']
      } else {
        return axios.defaults.baseURL + '/users/org/icon/'
      }
    },
    logoUrl () {
      if (process.env.NODE_ENV !== 'production' && (axios.defaults.params && axios.defaults.params['SUBDOMAIN'])) {
        return axios.defaults.baseURL + '/users/org/logo/?SUBDOMAIN=' + axios.defaults.params['SUBDOMAIN']
      } else {
        return axios.defaults.baseURL + '/users/org/logo/'
      }
    }
  },
  methods: {
    isOlderVersion,
    ...mapActions('auth', {
      logOutAction: 'logOut',
      syncToken: 'syncToken',
      setLastActivity: 'setLastActivity',
      syncLastActivity: 'syncLastActivity'
    }),
    logOut () {
      this.logOutAction()
        .then(() => {
          this.$router.push({ name: 'Login', query: { from: this.$route.fullPath } })
        })
    }
  },
  created () {
    window.addEventListener("offline", () => {
      this.offline = true
    })
    window.addEventListener("online", () => {
      this.offline = false
    })
    axios.interceptors.response.use(response => {
      if (response.headers && response.headers['x-cc-front-end-version']) {
        var versions = response.headers['x-cc-front-end-version'].split('/')
        var minRequired = versions[0]
        var minRecom = versions[1]
        if (isOlderVersion(this.version, minRequired)) {
          this.showForceRefresh = true
          return response
        }
        if (isOlderVersion(this.version, minRecom)) {
          this.showRecommendRefresh = true
          return response
        }
      }
      return response
    }, undefined)
    if (this.$route.query.org) {
      localStorage.setItem('development-org', this.$route.query.org)
    }
    if (localStorage.getItem('development-org')) {
      axios.defaults.params = {}
      axios.defaults.params['SUBDOMAIN'] = localStorage.getItem('development-org')
    }
    let file = document.createElement('link')
    file.rel = 'stylesheet'
    if (process.env.NODE_ENV !== "production" && (axios.defaults.params && axios.defaults.params['SUBDOMAIN'])) {
      file.href = axios.defaults.baseURL + '/users/org/stylesheet/?SUBDOMAIN=' + axios.defaults.params['SUBDOMAIN']
    } else {
      file.href = axios.defaults.baseURL + '/users/org/stylesheet/'
    }
    document.head.appendChild(file)
    this.setLastActivity()
  },
  onIdle() {
    clearInterval(this.interval)
    this.interval = setInterval(async () => {
      if (!this.loggedIn)
        return
      this.syncLastActivity()
      var now = moment(new Date())
      var end = moment.unix(this.lastActivity)
      var duration = moment.duration(now.diff(end))
      var minutesLastActive = duration.asMinutes()

      if (minutesLastActive < 15) {
        this.showTimeOut = false
      } else {
        this.showTimeOut = true
      }
    }, 1000)
  },
  onActive() {
    clearInterval(this.interval)
    this.interval = setInterval(() => {
      this.setLastActivity()
      this.showTimeOut = false
    }, 1000)
  }
}
